import React, { FC, ReactNode } from 'react';
import { Grid } from '@mui/material';
import { Label, Value } from './styles';

interface Props {
  children: ReactNode;
  label: string;
}

const LabelWithValue: FC<Props> = ({ children, label }: Props) => {
  return (
    <Grid item>
      <Label>{label}</Label>
      <Value>{children}</Value>
    </Grid>
  );
};

export default LabelWithValue;
